<template>
    <modal id="branch-create-edit-modal" size="extra-large" v-model="showModal" :title="generateModalTitle('branch')"
        @submit="submitData" :loading="loading" :preloader="preloader">

        <form ref="form" :data-url='selectedUrl ? selectedUrl : url' @submit.prevent="submitData" enctype="multipart/form-data">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Business Name')" :required="true"
                        :error-message="$errorMessage(errors, 'business_name')" :placeholder="$placeholder('Business Name')"
                        v-model="formData.business_name" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Company Name')" :required="true"
                        :error-message="$errorMessage(errors, 'company_name')" :placeholder="$placeholder('Company Name')"
                        v-model="formData.company_name" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Branch Name')" :required="true"
                        :error-message="$errorMessage(errors, 'name')" :placeholder="$placeholder('Branch Name')"
                        v-model="formData.name" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="number" :page="'modal'" :label="$t('Phone number')" :required="true"
                        :error-message="$errorMessage(errors, 'phone_number')" :placeholder="$placeholder('Phone number')"
                        v-model="formData.phone_number" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Email')" :required="true"
                        :error-message="$errorMessage(errors, 'email')" :placeholder="$placeholder('Email')"
                        v-model="formData.email" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="select" :list="statesList" list-value-field="value" :page="'modal'"
                        :label="$t('State')" :required="true" :error-message="$errorMessage(errors, 'stateid')"
                        :placeholder="$placeholder('State')" v-model="formData.stateid" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('City')" :required="true"
                        :error-message="$errorMessage(errors, 'city')" :placeholder="$placeholder('City')"
                        v-model="formData.city" />
                </div>
                <div class="col-12 col-sm-12 col-md-12">
                    <app-form-group type="textarea" :text-area-rows="3" :page="'modal'" :label="$t('Address')"
                        :required="true" :error-message="$errorMessage(errors, 'address')"
                        :placeholder="$placeholder('Address')" v-model="formData.address" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address 1')"
                        :error-message="$errorMessage(errors, 'address_1')" :placeholder="$placeholder('Address 1')"
                        v-model="formData.address_1" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address 2')"
                        :error-message="$errorMessage(errors, 'address_2')" :placeholder="$placeholder('Address 2')"
                        v-model="formData.address_2" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address 3')"
                        :error-message="$errorMessage(errors, 'address_3')" :placeholder="$placeholder('Address 3')"
                        v-model="formData.address_3" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('PIN')"
                        :error-message="$errorMessage(errors, 'pin')" :placeholder="$placeholder('PIN')"
                        v-model="formData.pin" />
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Website')" :required="true"
                        :error-message="$errorMessage(errors, 'website')" :placeholder="$placeholder('Website')"
                        v-model="formData.website" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="select" :list="WeightUnit" list-value-field="name" :page="'modal'"
                        :label="$t('Weight unit')" :required="true" :error-message="$errorMessage(errors, 'weight_unit')"
                        :placeholder="$placeholder('Weight Unit')" v-model="formData.weight_unit" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="select" :list="MeasurementsUnit" list-value-field="name" :page="'modal'"
                        :label="$t('Measurements unit')" :required="true" :error-message="$errorMessage(errors, 'measurements_unit')"
                        :placeholder="$placeholder('Measurements Unit')" v-model="formData.measurements_unit" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Branch Code')" :required="true"
                        :error-message="$errorMessage(errors, 'branch_code')" :placeholder="$placeholder('Branch Code')"
                        v-model="formData.branch_code" />
                </div>
                <div class="col-12 col-sm-12 col-md-12" style="margin-bottom:15px;">
                    <label class="form-label">Logo</label>
                    <input 
                        type="file" 
                        class="form-control" 
                        @change="handleLogoUpload" 
                        accept="image/*"
                    />
                    <!-- Preview Image -->
                    <div v-if="previewLogo || formData.logo" class="mt-2">
                        <img 
                            :src="previewLogo ? previewLogo : getExistingLogo(formData.logo)"
                            alt="Logo Preview" 
                            width="100" 
                            height="100"
                            style="border:1px solid #ccc;padding:5px;border-radius:5px"
                        />
                        <button type="button" 
                            class="btn btn-sm btn-outline-danger" @click="deleteLogo">
                            Delete
                        </button>
                    </div>
                </div>
                <br /> <!-- ✅ Added line break -->
                <div class="col-12 col-sm-6 col-md-3" >
                    <app-form-group type="select" :list="GSTTypeList" list-value-field="name" :page="'modal'"
                        :label="$t('GST Type')" :required="true" :error-message="$errorMessage(errors, 'GST_Type')"
                        :placeholder="$placeholder('GST Type')" v-model="formData.GST_Type" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('GSTIN')" :required="true"
                        :error-message="$errorMessage(errors, 'GSTIN')" :placeholder="$placeholder('GSTIN')"
                        v-model="formData.GSTIN" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Bill series prefix')" :required="true"
                        :error-message="$errorMessage(errors, 'bill_series_prefix')"
                        :placeholder="$placeholder('Bill series prefix')" v-model="formData.bill_series_prefix" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Proforma series prefix')" :required="true"
                        :error-message="$errorMessage(errors, 'perfoma_series_prefix')"
                        :placeholder="$placeholder('Proforma series prefix')" v-model="formData.perfoma_series_prefix" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Order series prefix')" :required="true"
                        :error-message="$errorMessage(errors, 'order_series_prefix')"
                        :placeholder="$placeholder('Order series prefix')" v-model="formData.order_series_prefix" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="select" :list="BranchTypeList" list-value-field="name" :page="'modal'"
                        :label="$t('Branch Type')" :required="true" :error-message="$errorMessage(errors, 'branch_type')"
                        :placeholder="$placeholder('Branch type')" v-model="formData.branch_type" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group type="select" :list="LocalWorkshop" list-value-field="name" :page="'modal'"
                        :label="$t('Local workshop')" :required="true"
                        :error-message="$errorMessage(errors, 'local_workshop')"
                        :placeholder="$placeholder('Local workshop')" v-model="formData.local_workshop" />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <label>{{ $t('Workshop') }}</label>
                    <app-input class="margin-right-8" type="search-and-select" :inputclearable="false"
                        :placeholder="$t('Select Workshop')" :options="workshopOptions" v-model="formData.workshop"
                        :error-message="$errorMessage(errors, 'workshop')" />
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                    <app-form-group :page="'modal'" :label="$t('Serial Number')" 
                        :error-message="$errorMessage(errors, 'cash_serial_no')" :placeholder="$placeholder('Serial Number')"
                        v-model="formData.cash_serial_no" />
                </div>
                
                <div class="col-12 col-sm-12 col-md-12">
                    <label style="font-size: 18px;"><b>Bank Details</b></label>
                </div>

                <!-- <div class="col-12 col-sm-12 col-md-12">
                    <app-form-group type="textarea" :text-area-rows="5" :page="'modal'" :label="$t('Enter Bank Details')"
                        :required="true" :error-message="$errorMessage(errors, 'bank_details')"
                        :placeholder="$placeholder('Enter Bank Details')" v-model="formData.bank_details" />
                </div> -->

                
                <div  class="col-12 col-sm-12 col-md-12">
                    <quill-editor class="form-control-quill" v-model="formData.bank_details" :label="$t('Enter Bank Details')" 
                    :options="editorOptions" :error-message="$errorMessage(errors, 'bank_details')"
                    :placeholder="$placeholder('Enter Bank Details')"  ></quill-editor>
                </div>

                <div class="col-12 col-sm-12 col-md-12" style="margin-top:10px;margin-bottom:15px;">
                    <label class="form-label">QR Code</label>
                    <input 
                        type="file" 
                        name="qr_code"
                        class="form-control" 
                        @change="handleQrUpload" 
                        accept="image/*"
                    />
                    <!-- Preview Image -->
                    <div v-if="previewQr || formData.qr_code" class="mt-2">
                        <img 
                            :src="previewQr ? previewQr : getExistingQr(formData.qr_code)"
                            alt="QR Code Preview" 
                            width="100" 
                            height="100"
                            style="border:1px solid #ccc;padding:5px;border-radius:5px"
                        />
                        <button  type="button" class="btn btn-sm btn-outline-danger" @click="deleteQr">Delete</button>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-12">
                    <label style="font-size: 18px;"><b>Alternate Payment</b></label>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group
                        type="select"
                        :list="AltPaymentMode"
                        list-value-field="name"
                        :page="'modal'"
                        :label="$t('Cash Invoice Prefix')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'cash_invoice_prefix')"
                        :placeholder="$placeholder('Cash Invoice Prefix')"
                        v-model="formData.cash_invoice_prefix"
                    />    
                </div>
                
                <!-- <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Cash Prefix')" 
                        :error-message="$errorMessage(errors, 'cash_prefix_name')" :placeholder="$placeholder('Cash Prefix')"
                        v-model="formData.cash_prefix_name" />
                </div> -->

                <div class="col-12 col-sm-12 col-md-12">
                    <label style="font-size: 16px;"><b>Terms & Conditions</b></label>
                </div>
                <div class="col-12 col-sm-12 col-md-12">
                    <quill-editor class="form-control-quill" :page="'modal'" :label="$t('Terms & Conditions')" 
                       :options="editorOptions"  :error-message="$errorMessage(errors, 'terms_conditions')"
                        :placeholder="$placeholder('Terms & Conditions')" v-model="formData.terms_conditions"  ></quill-editor>
                </div>

            </div>
        </form>

    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import { BRANCH_OR_WAREHOUSE, BRANCH_OR_WAREHOUSE_UPLOAD_FILES } from "../../../../Config/ApiUrl-CPB";
import { SELECTABLE_STATES } from "../../../../Config/ApiUrl-CP";
import { urlGenerator,axiosGet } from "../../../../../common/Helper/AxiosHelper";
import { formDataAssigner } from "../../../../../common/Helper/Support/FormHelper";

export default {
    name: "BranchCreateEditModal",
    extends: CoreLibrary,
    mixins: [FormHelperMixins, HelperMixin, ModalMixin],
    props: ['status'],
    data() {
        return {
            url: BRANCH_OR_WAREHOUSE,
            statusList: [],
            statesList: [],
            managerOptions: {
                url: urlGenerator("app/selectable/managers"),
                query_name: "search_by_name",
                per_page: 10,
                loader: "app-pre-loader", // by default 'app-overlay-loader'
                modifire: ({ id, full_name: value }) => ({ id, value }),
            },
            formData: {
                status_id: this.status.id,
                stateid: '',
                alt_payment_mode: '',
                type: "branch",
                account_type: "", 
                logo: null // <-- New field
            },
            previewLogo: null,
            previewQr: null,
            accountTypeList: [
                { id: "", name: "Select Account Type" },
                { id: "saving", name: "Saving Account" },
                { id: "current", name: "Current Account" },
                { id: "salary", name: "Salary Account" },
                { id: "fixed", name: "Fixed Deposit" }
            ],
            WeightUnit: [
                { id: '', name: this.$t('select_type') },
                { id: 'kgs', name: this.$t('kgs') },
                { id: 'lbs', name: this.$t('lbs') },
            ],
            MeasurementsUnit: [
                { id: '', name: this.$t('select_type') },
                { id: 'mm', name: this.$t('mm') },
                { id: 'cm', name: this.$t('cm') },
            ],
            GSTTypeList: [
                { id: '', name: this.$t('select_type') },
                { id: 'unregistered', name: this.$t('Unregistered') },
                { id: 'registered', name: this.$t('Registered') },
                { id: 'composite', name: this.$t('Composite') },
            ],
            BranchTypeList: [
                { id: '', name: this.$t('select_type') },
                { id: 'podiapro', name: this.$t('podiapro') },
                { id: 'partner', name: this.$t('partner') },
                { id: 'b2b', name: this.$t('B2B') },
            ],
            LocalWorkshop: [
                { id: '', name: this.$t('select_type') },
                { id: 'yes', name: this.$t('yes') },
                { id: 'no', name: this.$t('no') },
            ],
            AltPaymentMode: [
                { id: "", name: this.$t('select_type') },
                { id: 1, name: this.$t('yes') },
                { id: 0, name: this.$t('no') },
            ],
            workshopOptions: {
                url: urlGenerator("app/selectable-warehouses"),
                queryName: 'search_by_name',
                per_page: 10,
                loader: "app-pre-loader", // by default 'app-overlay-loader'
                modifire: (value) => ({ id: value.id, value: value.name }),
            },

            content: '', // editor content
            editorOptions: {
                placeholder: 'Write something...',
                theme: 'snow', // basic theme
                modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['link']
                ]
                }
            }
            
        }
    },
    mounted() {
        this.statesOptions();
    },
    methods: {
        statesOptions() {
            try {
                axiosGet(`${SELECTABLE_STATES}`).then(response => {
                    if(this.formData.stateid == '') this.formData.stateid = response.data.data[0].id;
                    for (let item of response.data.data) {
                        this.statesList.push({
                            id: item.id,
                            value: item.state,
                        });
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        handleLogoUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.formData.logo_new = file;
                this.previewLogo = URL.createObjectURL(file);
            }
        },
        handleQrUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.formData.qrCode = file;
                this.previewQr = URL.createObjectURL(file);
            }
        },
        // Get existing logo URL from storage
        getExistingLogo(logo) {
            if (!logo) return '/images/default-icon.png'; // fallback image
            return `${window.location.origin}/storage/logos/${logo}`;
        },
        getExistingQr(qr) {
            if (!qr) return '/images/default-icon.png'; // fallback image
            return `${window.location.origin}/storage/qr_codes/${qr}`;
        },
        showLoader(hide=false){
            $("div#app").addClass('apploader');
            if(hide) $("div#app").removeClass('apploader');
        },
        submitData() {
            this.showLoader();
            this.submitFromFixin(this.selectedUrl ? 'patch' : 'post', this.selectedUrl ?? this.url, this.formData);
        },
        
        afterSuccess({ data }) {
            if(data.status) {
                const formDataVal = new FormData();
                formDataVal.append("logo", this.formData.logo_new);
                formDataVal.append("qr_code", this.formData.qrCode);
                formDataVal.append("id", data.id);

                formDataVal.append("logo_blob", this.previewLogo);
                formDataVal.append("qr_code_blob", this.previewQr);

                try {
                    axios.post(urlGenerator(`${BRANCH_OR_WAREHOUSE_UPLOAD_FILES}`), formDataVal, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }).then(response => {
                        console.log(response);
                        this.showLoader(true);
                        // Handle response as needed
                        this.formData = {};
                        $('#branch-create-edit-modal').modal('hide');
                        this.$emit('branch-created');
                        this.toastAndReload(data.message, 'branches-and-warehouses-table');
                        setTimeout(() => {
                        // window.location.reload();
                        }, 1000)
                    }).catch(error => {
                        console.error(error);
                    });

                } catch (error) {
                    console.error(error);
                }
            }
            
        },

        deleteLogo() {
            if (confirm("Are you sure you want to delete this logo?")) {
                this.previewLogo = null;
                this.formData.logo = null;
                this.formData.logo_new = null;
                this.formData.isLogoDelete = true;

                const formDataVal = new FormData();
                formDataVal.append("isLogoDelete", true);
                formDataVal.append("id", this.formData.id);

                // Optional: If backend needs to delete existing file
                if (this.formData.id) {
                    try {
                        axios.post(urlGenerator(`${BRANCH_OR_WAREHOUSE_UPLOAD_FILES}`), formDataVal, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then(response => {
                            this.toastAndReload('Logo deleted successfully');
                        }).catch(error => {
                            console.error(error);
                        });

                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        },

        deleteQr() {
            if (confirm("Are you sure you want to delete this QR Code?")) {
                this.previewQr = null;
                this.formData.qr_code = null;
                this.formData.qrCode = null;

                // Optional: If backend needs to delete existing file
                if (this.formData.id) {
                    const formDataVal = new FormData();
                    formDataVal.append("isQrDelete", true);
                    formDataVal.append("id", this.formData.id);

                    // Optional: If backend needs to delete existing file
                    try {
                        axios.post(urlGenerator(`${BRANCH_OR_WAREHOUSE_UPLOAD_FILES}`), formDataVal, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then(response => {
                            this.toastAndReload('Qr Code deleted successfully');
                        }).catch(error => {
                            console.error(error);
                        });

                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        },
    }
}
</script>
<style scoped>
/* Editable area inside editor */
.form-control-quill .ql-editor {
  min-height: 100px;  /* min height for content area */
  overflow-y: auto;
  padding: 8px;
}

/* Scoped CSS requires ::v-deep to target Quill internal classes */
::v-deep(.form-control-quill .ql-container.ql-snow) {
  min-height: 100px;   /* minimum height for overall editor */
  border: 1px solid #ccc;
  border-radius: 4px;
}

::v-deep(.form-control-quill .ql-editor) {
  min-height: 100px;   /* minimum height for content area */
  overflow-y: auto;
  padding: 8px;
}
.btn-outline-danger {
    padding: 3px 8px;
    font-size: 12px;
}
</style>